var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMasterData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.89144 0H9.06618C9.53608 0 9.9701 0.250997 10.2046 0.658178L11.3854 2.27133C11.6199 2.67852 12.054 2.92951 12.5238 2.92951H29.9999V21.3471C29.9999 22.3144 29.2157 23.0986 28.2485 23.0986H1.75147C0.784189 23.0986 0 22.3144 0 21.3471V4.97259C0 3.61876 0.209164 2.273 0.620125 0.983038C0.770671 0.404106 1.29329 0 1.89144 0Z",
    fill: "#F2CA52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.89144 0H9.06618C9.53608 0 9.9701 0.250997 10.2046 0.658178L11.3854 2.27133C11.6199 2.67852 12.054 2.92951 12.5238 2.92951H29.9999V21.3471C29.9999 22.3144 29.2157 23.0986 28.2485 23.0986H1.75147C0.784189 23.0986 0 22.3144 0 21.3471V4.97259C0 3.61876 0.209164 2.273 0.620125 0.983038C0.770671 0.404106 1.29329 0 1.89144 0Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.79 2.62793H2.72998V12.3691H25.79V2.62793Z",
    fill: "#E8E8E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6864 0.875977H21.4562C20.9421 0.875977 20.4751 1.17598 20.2615 1.64364L19.0242 4.35136C18.8105 4.81902 18.3436 5.11903 17.8295 5.11903H0V21.7852C0 22.7525 0.784189 23.5367 1.75147 23.5367H28.2485C29.2158 23.5367 30 22.7525 30 21.7852V2.18958C30 1.46413 29.4118 0.875977 28.6864 0.875977Z",
    fill: "#F2CA52"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6864 0.875977H21.4562C20.9421 0.875977 20.4751 1.17598 20.2615 1.64364L19.0242 4.35136C18.8105 4.81902 18.3436 5.11903 17.8295 5.11903H0V21.7852C0 22.7525 0.784189 23.5367 1.75147 23.5367H28.2485C29.2158 23.5367 30 22.7525 30 21.7852V2.18958C30 1.46413 29.4118 0.875977 28.6864 0.875977Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterData);
export default __webpack_public_path__ + "static/media/masterData.6e0710f63be63f7022efc432322d8268.svg";
export { ForwardRef as ReactComponent };